import { Avatar, BottomSheet, Button, Typography } from '@/ui-kit';
import styles from './avatar-profile.module.scss';
import { ErrorNotificationIcon, FillProfileIcon, OkHandIcon, VerificationIcon, VerifiedAccountIcon } from '@/assets/icons';
import { routesApp } from '@/constans/routes';
import { profilesApi } from '@/api';
import { useAuth } from '@/store/useAuth';
import { useEffect, useState } from 'react';
import debounce from 'lodash/debounce';
import { callYaMetrika } from '@/utils/call-ya-metrika';
import { useToast } from '@/store/useToast';
import { useNavigate } from 'react-router-dom';
import WebApp from '@twa-dev/sdk';
import clsx from 'clsx';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

interface Props {
    avatar?: string;
    name?: string;
    // email?: string;
}

export const AvatarProfile: React.FC<Props> = ({ avatar, name }) => {
    const userData = useAuth((state) => state.getUser());
    const setUserData = useAuth((state) => state.setProfile);
    
    const showToast = useToast((state) => state.show);

    const [isActivated, setIsActivated] = useState<boolean | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isVerificationModalOpen, setIsVerificationModalOpen] = useState(false);

    useEffect(() => {
        setIsActivated(userData?.active ?? false);
    }, [userData]);

    const { t } = useTranslation();

    const navigate = useNavigate();

    const onMyFormPreviewClick = () => {
        callYaMetrika('my_form_preview');
        navigate(routesApp.myFormPreview)
    };

    return (
        <div className={styles.wrapper}>
            <div
                className={
                    clsx(
                        styles.avatarWrapper,
                        userData?.is_paid && styles['avatarWrapper--online']
                    )
                }
                onClick={onMyFormPreviewClick}>
                <Avatar
                    src={avatar}
                    size={120} />
                {/* <span className={styles.status}></span> */}
            </div>
            <div className={styles.nameAndVerificationStatusInfo}>
                <Typography
                    className={styles.name}
                    typeColor="black"
                    center>
                    {name}
                </Typography>
                {
                    userData
                        ?.verification_status
                        === 'verified' &&
                    <VerifiedAccountIcon
                        width={24}
                        height={24}
                        className={styles.verificationStatusInfo}
                        onClick={() => setIsVerificationModalOpen(true)} />
                }
            </div>

            <Button
                className={styles.button}
                textColor="black"
                to={routesApp.profileEdit}
                isLink>
                <FillProfileIcon />
                <span>{t('profile.fill_profile')}</span>
            </Button>

            <BottomSheet
                overlayClassName={styles.bottomsheetOverlay}
                isOpen={isVerificationModalOpen}
                isDeskorTop={false}
                onClose={() => setIsVerificationModalOpen(false)}>
                <div className={styles.verificationModalContent}>
                    <div className={styles.verificationModalContentIcon}>
                        <Avatar
                            src={avatar}
                            size={96} />
                        <VerifiedAccountIcon
                            className={styles.verificationModalContentIconVerification}
                            width={28}
                            height={28} />
                    </div>
                    <div className={styles.verificationModalContentHeader}>
                        <Typography
                            className={styles.verificationModalContentHeaderTitle}
                            variant={'h5'}
                            fontWeight={'bold'}>
                            {t('profile.verification_done')}
                        </Typography>
                        <Typography className={styles.verificationModalContentHeaderDesc}>
                            {t('profile.verification_status')}
                        </Typography>
                    </div>
                    <div className={styles.verificationModalContentFootnote}>
                        <Button
                            typeColor="orange"
                            className={styles.verificationModalContentFootnoteBtn}
                            onClick={() => setIsVerificationModalOpen(false)}>
                            {t('ok_tertiary')}
                        </Button>
                    </div>
                </div>
            </BottomSheet>

        </div>
    );
};
